import React from "react";

const Header = () => {
  return (
    <React.Fragment>
      <div className="login-header">
        <div className="login-header-inner">
          <a className="login-header-logo" href="/login" aria-label="IPCS workbench portal home">
            <img alt="IPCS" src="/assets/Img/logo.png" />
          </a>
          {/* <div className="login-header-title">
            <span>Workbench Portal</span>
            <strong>
              Next Generation Human Resource Onboarding, Contract, Time Log and Invoicing System
            </strong>
          </div>
          <a className="login-header-support" href="mailto:Support1@workfinity.com">
            <i className="fa fa-envelope-o" aria-hidden="true"></i>
            Support
          </a> */}
        </div>
      </div>

      <div className="login-welcome">
        <div className="login-welcome-content">
          <div className="login-welcome-brand">
            <span>Welcome to</span>
            <img alt="WorkFINITY" src="/assets/Img/logo_ft.png" />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Header;